<template>
  <div class="approval-row">
    <div
      class="approver-avatar"
      :style="{ background: meta.color + '1f', color: meta.color }"
    >
      {{ initials(approval.approverName) }}
    </div>
    <div class="approver-info">
      <div class="approver-name">{{ approval.approverName }}</div>
      <div v-if="approval.note" class="approver-note">« {{ approval.note }} »</div>
      <div v-else-if="approval.votedAt" class="approver-time">{{ relativeTime(approval.votedAt) }}</div>
      <div v-else-if="approval.nudgeCount > 0" class="approver-time">
        {{ $t('payout.nudgedCount', { count: approval.nudgeCount, time: relativeTime(approval.lastNudgedAt) }) }}
      </div>
    </div>
    <div class="approver-status">
      <f7-icon :f7="meta.icon" size="17" :style="{ color: meta.color }" />
    </div>
    <f7-button
      v-if="approval.decision === 'PENDING' && canNudge"
      small
      outline
      round
      class="nudge-btn"
      @click="$emit('nudge', approval.approverId)"
    >
      {{ $t('payout.nudge') }}
    </f7-button>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { decisionMeta } from '../../constants/payout-status.js'

const props = defineProps({
  approval: { type: Object, required: true },
  canNudge: { type: Boolean, default: false },
})
defineEmits(['nudge'])

const meta = computed(() => decisionMeta(props.approval.decision))

function initials(name) {
  return (name || '?').split(' ').map((w) => w.charAt(0)).slice(0, 2).join('').toUpperCase()
}

function relativeTime(iso) {
  if (!iso) return ''
  const mins = Math.floor((Date.now() - new Date(iso)) / 60000)
  if (mins < 60) return `${mins} min`
  const hours = Math.floor(mins / 60)
  if (hours < 24) return `${hours}h`
  return `${Math.floor(hours / 24)}j`
}
</script>

<style scoped>
.approval-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 4px;
  border-bottom: 1px solid var(--f7-list-item-border-color, #e0e0e0);
}
.approval-row:last-child { border-bottom: none; }
.approver-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 500;
  flex-shrink: 0;
}
.approver-info { flex: 1; min-width: 0; }
.approver-name { font-size: 12.5px; font-weight: 500; }
.approver-note { font-size: 10.5px; color: var(--f7-on-surface-variant, #8e8e93); font-style: italic; }
.approver-time { font-size: 10.5px; color: var(--f7-on-surface-variant, #8e8e93); }
.approver-status { flex-shrink: 0; }
.nudge-btn { flex-shrink: 0; }
</style>
